import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetAgentSessionEventsQuery,
  GetAgentSessionEventsQueryVariables,
} from "./GetAgentSessionEvents.generated";

export const GET_AGENT_SESSION_EVENTS: TypedDocumentNode<
  GetAgentSessionEventsQuery,
  GetAgentSessionEventsQueryVariables
> = gql`
  query getAgentSessionEvents(
    $agentSessionUuid: String!
    $after: String
  ) {
    agentSessionEvents(
      agentSessionUuid: $agentSessionUuid
      after: $after
    ) {
      events {
        id
        type
        content
        processedAt
        companionsUsed
      }
      nextPage
      turnInFlight
      pendingPermissions {
        requestId
        agentSessionUuid
        toolName
        toolAction
        toolKind
        title
        summary
        canPersist
        persistLabel
        grantDisplayName
        status
        expiresAt
        details {
          label
          value
        }
      }
    }
  }
`;
